import Joi from 'joi'

const calculationCouponFormSchema = Joi.object({
  coupon: Joi.object(),
  cashbox: Joi.object(),
})

export default calculationCouponFormSchema
